import { Search, SearchOrders } from 'features/searchTables';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { Logo } from 'shared/ui/logo';
import { Column, ProfileContainer, ProfilePopover, Wrapper } from './styles';
import { Menu, MenuItem } from 'shared/ui/menu';
import { ProfileButton } from 'shared/ui/buttons/profileButton/profileButton';

import menuTableIcon from 'shared/assets/icons/menu-table-icon-no-active.svg';
import menuListIcon from 'shared/assets/icons/menu-list-icon-no-active.svg';

import menuTableIconActive from 'shared/assets/icons/menu-table-icon.svg';
import menuListIconActive from 'shared/assets/icons/menu-list-icon.svg';

import calendarIconActive from 'shared/assets/icons/calendarWhite.svg';
import calendarIconNotActive from 'shared/assets/icons/calendar.svg';

import contactMainIcon from 'shared/assets/icons/contact-main.svg';
import contactIcon from 'shared/assets/icons/contact.svg';

import { useModal } from 'shared/lib/modal';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import {
	clearLoadedTable,
	resetBookingData,
	resetOrderDetail,
	resetOrderDetailPerson,
	selectWaitingOrders,
	setBookingThreadMod,
} from 'entities/orders';
import { resetPersonDetail } from 'entities/person';
import { selectTimeslots, useCurrentTimeslot } from 'entities/toolbar/timeslots';
import { useLocation } from 'react-router-dom';
import { Flex } from 'shared/ui/flex';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useOutClick } from 'app/lib/hooks/useOutClick';
import { ModalProvider } from 'shared/ui/modal';
import { LogoutConfirm } from './logoutConfirm';
import { isBefore, isToday } from 'date-fns';
import { DEFAULT_BG_COLOR } from 'shared/consts';
import { localStorageItem } from 'shared/lib/core/lib/utils';
import { useResize } from 'app/lib/hooks/useResize';
import { setBookingIsNew } from 'entities/orders/model/ordersSlice';
import { selectToBookingButtonDisabled } from 'entities/orders/model/selectors';
import { selectSettingBrancName } from 'entities/settings/model/selector';

export const Header = () => {
  // const ButtonWithLoader = withAsyncActionFeedback(ButtonContained, false, true);

	const { openModal } = useModal();
	const dispatch = useAppDispatch();
	const orders = useAppSelector(selectWaitingOrders);
	const timeslots = useAppSelector(selectTimeslots);
  const toBookingButtonDisabled = useAppSelector(selectToBookingButtonDisabled);
  const brandName = useAppSelector(selectSettingBrancName);
	const hasSaveBooking = Boolean(localStorageItem('booking'));

	const isDisabled = useMemo(() => {
		const firstTimeslotTime = timeslots?.[0]?.dt_start;

		if (firstTimeslotTime) {
			return isToday(firstTimeslotTime) ? isBefore(new Date(), firstTimeslotTime) : false;
		}

		return false;
	}, [timeslots])

	const [isOpenProfile, setOpenProfile] = useState(false);
	const [isOpenConfirm, setOpenConfirm] = useState(false);
	const ref = useRef(null)
	const { toCurrentTimeslot } = useCurrentTimeslot();

	const { pathname } = useLocation();

	const toBooking = (isNew = true) => {
    if (toBookingButtonDisabled) return;

		dispatch(resetBookingData());
		dispatch(resetOrderDetail());
		dispatch(resetOrderDetailPerson());
		dispatch(resetPersonDetail());
		dispatch(clearLoadedTable());
    if (isNew) {
      dispatch(setBookingIsNew({isNew:true}))
    }
		openModal();
	};

	const accomodateGuests = async () => {
		await toCurrentTimeslot();
		await dispatch(setBookingThreadMod({ isWork: true }));
		setTimeout(() => {
			toBooking(false);
		}, 200)
	};

	const toggleProfile = useCallback(() => {
		setOpenProfile(prev => !prev);
	}, [])

	useOutClick(ref, () => setOpenProfile(false))

  const { 
    isScreenSm
  } = useResize();

  useEffect(() => {
    if (brandName?.trim?.()) {
      document.title = `${brandName} | SlotBy.pro`
    }
  }, [brandName])

	return (
		<Wrapper>
			<Column>
				<Logo 
          brandName={brandName}
        />
			</Column>
      {
      isScreenSm && 
			<Column>
				<Menu>
					<MenuItem
						iconSrc={menuTableIcon}
						iconSrcActive={menuTableIconActive}
						link="/"
					/>
					<MenuItem
						iconSrc={menuListIcon}
						iconSrcActive={menuListIconActive}
						iconButtonStyles={{
							iconHeight: '17px',
							paddingButton: '9px 6px',
						}}
						link="/bookings"
					/>
					<MenuItem
						iconSrc={calendarIconNotActive}
						iconSrcActive={calendarIconActive}
						link="/waiting-list"
						counter={orders.length}
					/>
					<MenuItem
						iconSrc={contactMainIcon}
						iconSrcActive={contactIcon}
						link="/contact-book"
					/>
				</Menu>
			</Column>
      }

      {
        isScreenSm && (pathname === '/' ? <SearchOrders hide={pathname !== '/'} /> : <Search hide={pathname === '/'} />)
      }

      {
        isScreenSm &&
        <Column>
          <Flex $gap="10px">
            {hasSaveBooking ? (
              <ButtonContained
                onClick={() => toBooking()}
                padding="8px 30px"
                background={DEFAULT_BG_COLOR}
                color="main"
                withTag
                id='to-booking-btn'
                disabled={toBookingButtonDisabled}
              >
                Забронировать
              </ButtonContained>
            ) : (
              <ButtonContained
                onClick={() => toBooking()}
                padding="8px 30px"
                id='to-booking-btn'
                disabled={toBookingButtonDisabled}
              >
                Забронировать
              </ButtonContained>
            )}

            <ButtonContained
              onClick={accomodateGuests}
              padding="8px 30px"
              disabled={isDisabled}
            >
              Разместить
            </ButtonContained>
            {/* disablePreloader={timeslots.length ? true : false} */}
          </Flex>
        </Column>
      }

			<ProfileContainer ref={ref}>
				<ProfileButton onClick={toggleProfile}>A</ProfileButton>
				{isOpenProfile && (
					<ProfilePopover>
						<ButtonContained onClick={() => {
							setOpenConfirm(true);
							setOpenProfile(false);
						}}>
							Выйти из аккаунта
						</ButtonContained>
					</ProfilePopover>
				)}
			</ProfileContainer>
			{isOpenConfirm && (
				<ModalProvider openByDefault>
					<LogoutConfirm onClose={() => setOpenConfirm(false)} />
				</ModalProvider>
			)}
		</Wrapper>
	);
};
